export interface NewsItem {
  id: string;
  title: string;
  date: string;
  category: string;
  excerpt: string;
}

export const newsItems: NewsItem[] = [
  {
    id: '6',
    title: 'OMFESウェブサイト正式公開のお知らせ',
    date: '2026年5月15日',
    category: 'お知らせ',
    excerpt: '一般社団法人東洋医学未来推進協会（OMFES）の公式ウェブサイトを正式に公開いたしました。今後は本サイトを通じて、協会の活動情報や最新のお知らせを随時発信してまいります。',
  },
  {
    id: '1',
    title: '一般社団法人東洋医学未来推進協会（OMFES）設立のご報告',
    date: '2026年4月1日',
    category: 'お知らせ',
    excerpt: '2026年4月1日、一般社団法人東洋医学未来推進協会（OMFES）を正式に設立いたしました。東洋医学の発展と普及に向けて、関係各位と連携しながら活動を推進してまいります。',
  },
  {
    id: '2',
    title: '第75回全日本鍼灸学会学術大会（岡山）への出展について',
    date: '2026年3月15日',
    category: '活動報告',
    excerpt: '2026年5月に岡山で開催される第75回全日本鍼灸学会学術大会に、OMFES協賛企業・団体として出展する予定です。詳細は決まり次第お知らせいたします。',
  },
  {
    id: '3',
    title: '協賛・会員募集のご案内',
    date: '2026年2月28日',
    category: '入会・協賛',
    excerpt: 'OMFESでは現在、東洋医学の発展に賛同いただける企業・団体・個人の会員および協賛を広く募集しています。詳細はお問い合わせください。',
  },
  {
    id: '4',
    title: '2026年度 学術大会・総会 開催スケジュールのお知らせ',
    date: '2026年2月10日',
    category: 'イベント',
    excerpt: '2026年度の学術大会・総会の開催スケジュールが決定しました。5月の全日本鍼灸学会学術大会（岡山）、10月の東洋療法学校協会学術大会（東京）など複数の大会への参加を予定しています。',
  },
  {
    id: '5',
    title: '第21回日本鍼灸師会全国大会（神戸）参加予定のご案内',
    date: '2026年1月20日',
    category: 'イベント',
    excerpt: '2026年10月に神戸で開催される第21回日本鍼灸師会全国大会に、OMFESとして参加・展示を予定しております。詳細はスケジュールが確定次第、改めてお知らせします。',
  },
  {
    id: '7',
    title: '第47回東洋療法学校協会学術大会（東京）への参加について',
    date: '2025年12月18日',
    category: '活動報告',
    excerpt: '2026年10月に東京で開催される第47回東洋療法学校協会学術大会への参加を予定しています。東洋医学教育の発展に向けた連携を深める機会として積極的に参画してまいります。',
  },
  {
    id: '8',
    title: '役員体制決定のお知らせ',
    date: '2025年12月1日',
    category: 'お知らせ',
    excerpt: '東洋医学未来推進協会の役員体制が決定いたしました。会長に押谷小助氏（株式会社山正）を筆頭に、鍼灸関連業界を代表する9名の役員により協会を運営してまいります。',
  },
];

export const categories = ['すべて', 'お知らせ', '活動報告', '入会・協賛', 'イベント'];
